import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-green-500/10 border-b border-green-500/20 text-green-400 text-sm font-medium py-3 px-4 text-center" style={{
    fontSize: "12px",
    paddingTop: "1px",
    paddingBottom: "1px"
  }} data-id="element-13" data-mp="2tgqmyhggroie">
      <span className="font-bold" data-id="element-14" data-mp="jsioey019hxl">LIMITED TIME:</span>  The Second-Half Performance Bundle. Get the Complete System + 2 Free Bonuses (Save 80%)
    </div>;
}